

























































// Vue
import { computed, defineComponent } from '@vue/composition-api'

// components
import { Select2, Select } from '@/components/general'

// utils
import { dateLibs } from '@/utils'

// constants
import {
  optionsWorkCategory
} from '@/constants'

export default defineComponent({
  name: 'FiltersWorkSheetsIndex',
  components: {
    Select2,
    Select
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup () {
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault

    const optionsWorkCategories = computed(() => {
      return [
        ...optionsWorkCategory
      ]
    })

    return {
      years,
      months,
      fortnights,
      optionsWorkCategories
    }
  }
})
